import { Image, Film, LayoutGrid, Camera } from 'lucide-react';

export const POST_TYPES = [
  { value: 'image', label: 'Foto', icon: Image, accept: 'image/jpeg,image/png', maxFiles: 1 },
  { value: 'carousel', label: 'Carrossel', icon: LayoutGrid, accept: 'image/jpeg,image/png', maxFiles: 10 },
  { value: 'reel', label: 'Reel', icon: Film, accept: 'video/mp4,video/quicktime', maxFiles: 1 },
  { value: 'story', label: 'Story', icon: Camera, accept: 'image/jpeg,image/png,video/mp4', maxFiles: 1 },
];

export const columnColors = {
  yellow: { header: 'border-yellow-500', count: 'bg-yellow-100 text-yellow-700', countDark: 'bg-yellow-900/20 text-yellow-400' },
  blue: { header: 'border-nomoz-navy', count: 'bg-blue-100 text-blue-700', countDark: 'bg-blue-900/20 text-blue-400' },
  green: { header: 'border-green-500', count: 'bg-green-100 text-green-700', countDark: 'bg-green-900/20 text-green-400' },
};
